import React, {Fragment, useEffect, useState} from 'react';
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Paper,
    Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow
} from "@mui/material";
import {Check} from "react-feather";
import {GrantAccountStatementService, GrantDetailService} from "../shared/service";

const AddGrantModal = (props) => {
    const [grantList, setGrantList] = useState([])
    const {grantOpen, handleClose, period} = props;
    const [selectedGrants, setSelectedGrants] = useState([]);
    const [allSelected, setAllSelected] = useState(false);

    useEffect(() => {
        setSelectedGrants([]);
        if(grantOpen) {
            GrantDetailService.getNotInPeriod(period)
                .then((response) => {
                    setGrantList(response.data);
                });
        }
    }, [grantOpen, period]);

    const selectGrant = (val) => {
        let sg = [...selectedGrants];
        if (selectedGrants.indexOf(val) >= 0) {
            setSelectedGrants(sg.filter(g => g !== val));
        } else {
            sg.push(val);
            setSelectedGrants(sg);
        }
    }

    const isSelected = (val) => {
        return selectedGrants.indexOf(val) >= 0;
    }

    const toggleSelectAll = () => {
        if (!allSelected) {
            setSelectedGrants(grantList.map(g => g.id));
        } else {
            setSelectedGrants([]);
        }
        setAllSelected(!allSelected);
    }

    const addAllGrants = () => {
        GrantAccountStatementService.addMultipleGrants(period, selectedGrants)
            .then((response) => {
                if (response.data && !response.data.error) {
                    props.setSnackBarMessage("Grants added to period.", "success");
                    props.setGrantList(response.data);
                    handleClose();
                }
            }).catch((response) => {
            props.setSnackBarMessage("Grants could not be added to period.", "error");
        });
    }


    return (
        <div>
            <Dialog open={grantOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add Document set</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please select a grant and click Add.
                    </DialogContentText>

                    <Grid>
                        <Grid item xs={12}>
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <input onClick={(val) => toggleSelectAll()} checked={allSelected}
                                                       type="checkbox"/>
                                            </TableCell>
                                            <TableCell>Grant Name</TableCell>
                                            <TableCell>Country</TableCell>
                                            <TableCell>Verified</TableCell>
                                            <TableCell>&nbsp;</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            grantList.map((row) => (
                                                <Fragment key={row.id}>
                                                    <TableRow>
                                                        <TableCell>
                                                            <input onClick={(val) => selectGrant(row.id)}
                                                                   checked={isSelected(row.id)} type="checkbox"/>
                                                        </TableCell>
                                                        <TableCell style={{padding: 10, paddingLeft: 10, margin: 0}}
                                                                   component="td"
                                                                   scope="row">
                                                            {row.grantName}
                                                        </TableCell>
                                                        <TableCell style={{padding: 10, paddingLeft: 10, margin: 0}}
                                                                   component="td"
                                                                   scope="row">
                                                            {row.countryName}
                                                        </TableCell>
                                                        <TableCell style={{padding: 10, paddingLeft: 10, margin: 0}}
                                                                   component="td"
                                                                   scope="row">
                                                            {
                                                                row.emailsValidated &&
                                                                <Check color='green'/>
                                                            }
                                                        </TableCell>
                                                        <TableCell style={{padding: 0, margin: 0, paddingLeft: 5}}>

                                                        </TableCell>
                                                    </TableRow>
                                                </Fragment>))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={selectedGrants.length === 0} onClick={() => addAllGrants()} color="primary" variant="contained">
                        Add Grants
                    </Button>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default AddGrantModal;
